"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
var breakpoints_scss_1 = __importDefault(require("./breakpoints.scss"));
exports.breakpoints = {
    values: {
        xs: parseInt(breakpoints_scss_1.default.xs, 10),
        sm: parseInt(breakpoints_scss_1.default.sm, 10),
        md: parseInt(breakpoints_scss_1.default.md, 10),
        lg: parseInt(breakpoints_scss_1.default.lg, 10),
        xl: parseInt(breakpoints_scss_1.default.xl, 10),
    },
};
